export const topBarHeight = 45
export const sideNavWidth = 220
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200

export const base_url = 'https://panel-be.deliveryfast.com.bd/api/'  
export const business_name ='Delivery Fast'
export const business_address ='#06, Road #2/A, Banani, Dhaka-1213'
export const business_email ='deliveryfastltd@gmail.com'
export const business_web ='www.deliveryfast.com.bd'
export const business_hotline ='+8801969 921 122'
// content
export const footer_copyrights_text_right = ''
export const footer_copyrights_text_left =  '© 2025 Delivery Fast. All Rights Reserved.';
export const site_name='Delivery Fast';
 